import { env } from '@/constants/configs'

export function createHeaders(values?: Record<'name' | 'value', string>[]) {
  const headers = new Headers()
  headers.set('Secretkey', env.API_SECRET_KEY)

  if (values?.length) {
    for (const record of values) {
      headers.set(record.name, record.value)
    }
  }

  return headers
}

export function getClientIPFromHeaders(
  headersList: Headers | Record<string, string>
): string | null {
  const ipHeaders = [
    'x-forwarded-for',
    'x-real-ip',
    'cf-connecting-ip',
    'x-client-ip',
    'x-forwarded',
    'forwarded-for',
    'forwarded'
  ]

  for (const header of ipHeaders) {
    let value: string | null = null

    if (headersList instanceof Headers) {
      value = headersList.get(header)
    } else {
      value = headersList[header] || headersList[header.toLowerCase()] || null
    }

    if (value) {
      const ip = value.split(',')[0].trim()
      if (ip && ip !== 'unknown') {
        return ip
      }
    }
  }

  return null
}
